// extracted by mini-css-extract-plugin
export default {"betCartButton":"betCartButton_betCartButton__awaVH","cartIcon":"betCartButton_cartIcon__ALkeY","badge":"betCartButton_badge__owOVQ"};